import { observer } from "mobx-react-lite"
import "./about.css"
import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

const KanbanView = observer(() => {
    const { t } = useTranslation();
    
    return (
        <div>
                <h1><img src={`/assets/about/tabs/${i18n.language}/kanban_icon_title.svg`} alt="" /> <span className="blue-text">{t("KANBAN")}</span> <span className="rubik">{t("VIEW")}</span> </h1>

            <div className="row">
                <div className="features-description">{t("Your team’s workflow — now visual, flexible, and fast.")}</div>
                <Flex justify="center">
                    <div className="features-image">
                        <img src={`/assets/about/tabs/${i18n.language}/kanban-view-img.svg`} alt="" /> 
                    </div>
                </Flex>
                <p className="features-description-center">{t("Drag tasks. Drop chaos. Plan like a pro with boards that speak your team’s language.")}</p>
                <div className="blue-hr"></div>
            </div>
        </div>
    )
})
export default KanbanView;